import type { InviteAccessState, InviteDeliveryState } from '@/types/userRoles'

/** The states that mean somebody cannot currently get in, and the list should surface them. */
export const STUCK_ACCESS_STATES: InviteAccessState[] = [
  'Invited',
  'InviteExpired',
  'NoInvitationOnRecord',
  'SignedInNotAMember',
]

/** Whether re-inviting could plausibly help. Suppressed addresses are a dead end until the address changes. */
export function canReInvite(state: InviteAccessState, delivery: InviteDeliveryState | undefined): boolean {
  if (!STUCK_ACCESS_STATES.includes(state)) return false
  return delivery !== 'Suppressed' && delivery !== 'Bounced'
}

/**
 * Sort order for the status column: whoever needs attention first, most stuck first within that.
 * Sorting the raw state name instead puts "Invite expired" above "Invited" purely on spelling, and
 * scatters the people an admin came here to find.
 */
const ACCESS_URGENCY: Record<InviteAccessState, number> = {
  NoInvitationOnRecord: 0,
  InviteExpired: 1,
  SignedInNotAMember: 2,
  Invited: 3,
  StatusUnavailable: 4,
  NoInviteRequired: 5,
  Active: 6,
}

export function accessUrgency(state: InviteAccessState | undefined): number {
  return state === undefined ? Number.MAX_SAFE_INTEGER : ACCESS_URGENCY[state]
}
